import { Card, Col } from 'react-bootstrap';
import CountPill from './CountPill';

import AddButton from './AddButton';
import { admin_tg } from './constants'
import Variants from './Variants';


export default function ProductCard({ id, product, addProduct, rmProduct }) {
    

    const imageLink = require(`./../pics/${product.picture}`)
    const concentrateLine = product.concentrate ? product.concentrate.join(' • ') : null

    return (
        <Col>
            <Card className='product-card'>
                <div className='product-card__media'>
                    <CountPill product={product} />
                    <Card.Img className='product-card__image' variant="top" src={imageLink} />
                </div>
                <Card.Body className='product-card__body'>
                    <div>
                        <Card.Title className='product-card__title'>{product.name}</Card.Title>
                        {product.desc && <p className='product-card__desc'>{product.desc}</p>}
                    </div>
                    <Variants variants={product.variants}></Variants>
                    {(product.volume || concentrateLine) && (
                        <div className='product-card__meta'>
                            {product.volume && <span>{product.volume}</span>}
                            {concentrateLine && <span>{concentrateLine}</span>}
                        </div>
                    )}
                    <div className='product-card__actions'>
                        {product.count > 0 && <button className="Button Button--ghost" onClick={() => rmProduct(id)}>🗑️</button>}
                        {product.count === 0 && <button className="Button Button--ghost" onClick={() => window.location.href='https://t.me/' + admin_tg}>👋ІНФО</button>}
                        <AddButton id={id} admin_tg={admin_tg} addProduct={addProduct} />
                    </div>

                </Card.Body>
            </Card>
        </Col>
    )
}
